<template>
  <roe-error-message :field="design.employer_other_flat_dollar_amount">
    <input
      name="employer_other_flat_dollar_amount"
      type="number"
      v-model.number="design.$model.employer_other_flat_dollar_amount"
    />
    <label class="input-label-inside">$</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerOtherFlatDollarInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
